export const SET_ASSIGNMENTS_FOR_CAMPAIGN = "CAMPAIGN_SET_ASSIGNMENTS_FOR_CAMPAIGN"; // for campaign that is
export const CHANGE_ASSIGNMENT_SELECTION = "CAMPAIGN_CHANGE_ASSIGNMENT_SELECTION";  // agent picked one or more assignments
export const SELECT_SINGLE_ASSIGNMENT = "CAMPAIGN_SELECT_SINGLE_ASSIGNMENT";
export const ASSIGNMENTS_CHANGE = "CAMPAIGN_ASSIGNMENT_CHANGE";   // assignment (for campaign)
                                                        // added, deleted, edited :re-retrieve assignment list for campaign
                                                        // before next use

// prefix contstant values to avoid name conflict between action types